<template>
  <v-container v-if="shouldShowSearch" fill-height>
    <v-row align="center" justify="center">
      <v-col cols="5">
        <v-card v-bind:class="{ 'ui-module-card': !loading, 'card-flat': loading }" color="primary">
          <v-card-title class="ui-module-titlebar"> Ingrese CUIP </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <BaseInput v-model="busquedaPersonal.CUIP" label="Buscar personal" :disabled="loadingBusqueda">
                  </BaseInput>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    rounded
                    block
                    large
                    color="secondary"
                    class="btn-buscar ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loadingBusqueda || loading"
                    :loading="loadingBusqueda"
                  >
                    Buscar <v-icon class="ml-2">mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-virtual-scroll :items="personal" item-height="98" height="300">
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.idPersonal" link @click="triggerFetchPersonalWeapons(item)">
                        <v-list-item-avatar size="80">
                          <v-img :src="item.foto" v-if="item.foto !== ''"></v-img>
                          <v-icon size="48" v-else>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="text-subtitle-2 font-weight-bold">{{ getFullName(item) }}</div>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <div v-if="item.CUIP.length > 0">{{ item.CUIP }}</div>
                            <div v-else>CUIP no asignado</div>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle> Estatus: {{ item.CatEstatus.title }} </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            Vigencia C3:
                            {{ item.vigenciaEvaluacionC3 === '' ? 'No registrado' : item.vigenciaEvaluacionC3 }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="selectedPersonal" fluid>
    <v-row>
      <v-col cols="1">
        <v-btn text v-on:click="goBack()">
          <v-icon class="pr-2">mdi-arrow-left</v-icon>
          Regresar
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="stretch">
      <v-col cols="3" class="fill-height">
        <v-card class="ui-module-card" color="primary" height="100%">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center"
            >Información del personal</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="12" align="center">
                  <v-img contain :src="selectedPersonal.foto" max-width="80"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="pb-0">
                  <div class="text-subtitle-1 text--primary">
                    {{
                      selectedPersonal.nombre +
                      ' ' +
                      selectedPersonal.segundoNombre +
                      ' ' +
                      selectedPersonal.apaterno +
                      ' ' +
                      selectedPersonal.amaterno
                    }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="text-subtitle-2 secondary--text">Datos generales</div>
                </v-col>
                <v-col cols="12" align="left" class="pb-0">
                  <div class="text-caption mb-1">CUIP</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.CUIP }}</div>
                </v-col>
                <v-col cols="12" align="left" class="pb-0">
                  <div class="text-caption mb-1">CURP</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.curp }}</div>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="text-subtitle-2 secondary--text">Contacto</div>
                </v-col>
                <v-col cols="6" class="pb-0">
                  <div class="text-caption mb-1">Teléfono celular</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.telefonoCelular }}</div>
                </v-col>
                <v-col cols="6" class="pb-0">
                  <div class="text-caption mb-1">Teléfono fijo</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.telefonoFijo }}</div>
                </v-col>
                <v-col cols="12" align="left" class="pb-0">
                  <div class="text-caption mb-1">E-mail</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.correoElectronico }}</div>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="text-subtitle-2 secondary--text pb-2">Puesto y área del elemento</div>
                </v-col>
                <v-col cols="12" align="center" v-if="selectedPersonal.CatPuestoDependencia">
                  <div class="text-caption mb-1">Puesto</div>
                  <div class="text-body-1 text--primary">
                    {{ selectedPersonal.CatPuestoDependencia.catPuesto.puesto }}
                  </div>
                </v-col>
                <v-col cols="12" align="center" v-if="selectedPersonal.CatArea">
                  <div class="text-caption mb-1">Área</div>
                  <div class="text-body-1 text--primary">{{ selectedPersonal.CatArea.title }}</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col cols="12" class="fill-height">
            <v-card v-bind:class="{ 'ui-module-card': !loading, 'card-flat': loading }" color="primary" height="100%">
              <v-card-title class="ui-module-titlebar font-weight-bold">Lista de armas</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        class="primary armory-table ui-module-table"
                        dense
                        :headers="personalWeaponsTableHeaders"
                        :items="armasPersonal"
                        :search="searchPersonalWeapon"
                        hide-default-footer
                        calculate-widths
                      >
                        <template v-slot:[`item.cancelacion`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click="openEditArmaDialog(item)"
                                ><v-icon>mdi-pencil</v-icon></v-btn
                              >
                            </template>
                            <span>Editar asignación</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="error"
                                v-bind="attrs"
                                v-on="on"
                                @click="triggerCancelaArmaPersonal(item)"
                                ><v-icon>mdi-minus</v-icon></v-btn
                              >
                            </template>
                            <span>Quitar arma</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:[`item.personalWeaponStatus`]="{ item }">
                          <div class="d-flex justify-center">
                            <v-switch
                              class="personal-weapon-status-switch"
                              :input-value="getArmaPersonalEstatus(item)"
                              color="secondary"
                              @change="triggerSaveEntregaRecepcion(item, $event)"
                              inset
                              hide-details
                            >
                            </v-switch>
                          </div>
                        </template>
                        <template v-slot:[`item.opciones`]="{ item }">
                          <span class="d-flex align-center justify-end">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="mr-2">
                                  <IconButton variant="secondary" icon="mdi-ammunition" @click="openMunicionesArmaDialog(item)" />
                                </span>
                              </template>
                              <span>Municiones</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  <IconButton variant="secondary" icon="mdi-history" @click="openAccesoriosArmaDialog(item)" />
                                </span>
                              </template>
                              <span>Accesorios asignados</span>
                            </v-tooltip>
                          </span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="downloadWeaponDialog" width="360">
      <v-card>
        <v-card-title class="justify-center">Descarga de arma</v-card-title>
        <v-card-text class="text-body-1">
          Para ubicar el arma en armería, es necesario realizar previamente una descarga. Si la descarga de arma ya ha
          sido realizada, marque la siguiente casilla y a continuación de click en Aceptar.
          <v-checkbox
            v-model="downloadWeaponStatus"
            label="Se ha realizado la descarga de arma"
            color="secondary"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text v-on:click="closeDownloadWeaponDialog()">Cancelar</v-btn>
          <v-btn color="secondary" v-on:click="triggerUpdateWeaponStatus()" :disabled="!downloadWeaponStatus"
            >Guardar arma</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editArmaDialog" width="420">
      <v-card>
        <v-card-title class="justify-center">Editar asignación de arma</v-card-title>
        <v-card-text class="text-body-1">
          <v-autocomplete
            v-model="editArmaSeleccionada"
            filled
            rounded
            dense
            :items="filteredArmasEdicion"
            item-value="idArma"
            item-text="CatModelo.modelo"
            no-data-text="No se encontraron armas"
            label="Nueva arma"
            hint="Puedes escribir para filtrar por modelo"
            persistent-hint
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text v-on:click="closeEditArmaDialog()">Cancelar</v-btn>
          <v-btn
            color="secondary"
            :loading="loadingEditArma"
            :disabled="!editArmaSeleccionada"
            v-on:click="confirmEditArmaPersonal()"
            >Guardar cambios</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <municiones-arma-dialog-component
      :active="municionesArmaDialog"
      @close="municionesArmaDialog = false"
    ></municiones-arma-dialog-component>
  </v-container>
  <v-container v-else fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular indeterminate color="secondary" size="48" v-if="loading" />
        <div class="text-subtitle-1" v-else>Seleccione un elemento para pase de lista.</div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.btn-buscar {
  box-shadow: 0 4px 16px rgba(108, 92, 231, 0.35) !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  transition: all 0.25s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.12) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle,
::v-deep .text-subtitle-1,
::v-deep .text-body-1,
::v-deep .text-caption {
  color: #e0e0e0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}

.personal-weapon-status-switch {
  flex: 0 0 auto;
  margin-top: 0;
  padding-top: 0;
}

::v-deep .personal-weapon-status-switch .v-input__control {
  width: auto;
}

::v-deep .personal-weapon-status-switch .v-input--selection-controls__input {
  width: auto;
  height: auto;
}

::v-deep .personal-weapon-status-switch .v-input--selection-controls__ripple {
  display: none;
}

::v-deep .personal-weapon-status-switch .v-input--switch__track {
  opacity: 1;
}

::v-deep .personal-weapon-status-switch .v-input--switch__thumb {
  box-shadow: none;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import MapComponent from '../../components/MapComponent'
import MunicionesArmaDialogComponent from '../../components/armeria/MunicionesArmaDialogComponent.vue'
import AccesoriosAsignadosDialogComponent from '../../components/armeria/AccesoriosAsignadosDialogComponent.vue'
import IconButton from '@/components/base/IconButton.vue'
import TextButton from '@/components/base/TextButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'

export default {
  components: {
    // LoaderComponent,
    MapComponent,
    MunicionesArmaDialogComponent,
    AccesoriosAsignadosDialogComponent,
    IconButton,
    TextButton,
    BaseInput,
  },

  beforeRouteLeave(to, from, next) {
    this.RESET_BUSQUEDA_PERSONAL()
    next()
  },

  data() {
    return {
      loading: false,
      card: 'card',
      flatCard: 'card-flat',
      weaponDailyRollCallDialog: false,
      activeStep: 1,
      searchItemValue: '',
      selectedPersonal: null,
      cuipForm: false,
      cuip: null,
      successfulCuipSearch: null,
      fetchingPersonalWeapons: false,
      required: [(v) => !!v || 'Este campo es requerido. '],
      DIALOG_TYPES,

      personalWeaponsTableHeaders: [
        { text: '', value: 'cancelacion', width: '5%' },
        { text: 'Clase', value: 'Arma.CatClase.clase', width: '10%' },
        { text: 'Tipo', value: 'Arma.CatClase.CatTipo.title', width: '10%' },
        { text: 'Marca', value: 'Arma.CatModelo.CatMarca.title', width: '10%' },
        { text: 'Modelo', value: 'Arma.CatModelo.modelo', width: '10%' },
        { text: 'Calibre', value: 'Arma.CatCalibre.title', width: '10%' },
        { text: 'No. de serie', value: 'Arma.serie', width: '10%' },
        { text: 'Armeros', value: 'Arma.armeros', width: '20%' },
        { text: 'En armería | En campo', value: 'personalWeaponStatus', width: '20%', filterable: false },
        { text: 'Opciones', value: 'opciones', align: 'right', sortable: false, filterable: false },
      ],

      searchPersonalWeapon: '',

      downloadWeaponDialog: false,
      downloadWeaponStatus: false,
      weaponToUpdate: null,

      editArmaDialog: false,
      editArmaSeleccionada: null,
      loadingEditArma: false,
      armaPersonalAEditar: null,

      x: null,

      municionesArmaDialog: false,

      busquedaPersonal: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: '',
      },

      loadingBusqueda: false,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
      personalSingle: 'getPersonalSingle',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('tipoArma', {
      weaponTypes: 'getTipoArmas',
    }),

    ...mapGetters('marcaArma', {
      weaponBrands: 'getMarcaArma',
    }),

    ...mapGetters('arma', {
      weapons: 'getArmas',
    }),

    ...mapGetters('estatusArma', {
      weaponStatus: 'getEstatusArma',
    }),

    idsEstatusPermitidos: function () {
      const ESTATUS_PERMITIDOS = ['ACTIVO', 'ASIGNADO']
      return this.weaponStatus
        .filter((estatus) => ESTATUS_PERMITIDOS.includes((estatus.title || '').trim().toUpperCase()))
        .map((estatus) => estatus.id)
    },

    filteredArmasEdicion: function () {
      return this.weapons.filter((arma) => this.idsEstatusPermitidos.includes(arma.fk_idEstatus))
    },

    ...mapGetters('tipoEntregaArma', {
      tipoEntrega: 'getTiposEntrega',
    }),

    ...mapGetters('bitacoraEntregaRecepcion', {
      bitacora: 'getBitacoraEntregaRecepcion',
    }),

    preselectedFromRoute() {
      return !!this.$route.query.idPersonal
    },

    shouldShowSearch() {
      return !this.selectedPersonal && !this.preselectedFromRoute
    },
  },

  async created() {
    this.initFromRoute()
    if (this.weaponStatus.length === 0) {
      await this.fetchEstatusArma()
    }
    if (this.weapons.length === 0) {
      await this.fetchArmas()
    }
  },

  methods: {
    ...mapActions('armaPersonal', [
      'fetchArmasPersonal',
      'updateEstatusArmaPersonal',
      'cancelaArmaPersonal',
      'editArmaPersonal',
    ]),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('entregaRecepcionArma', ['saveEntregaRecepcionArma']),
    ...mapActions('municionArma', ['fetchMunicionArma']),
    ...mapActions('bitacoraEntregaRecepcion', ['fetchBitacoraEntregaRecepcion']),
    ...mapActions('personal', ['searchPersonal', 'fetchPersonalById']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),

    openAccesoriosArmaDialog(armaPersonal) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.ACCESORIOS_ASIGNADOS_ARMAS,
        props: { armaPersonal },
      })
    },

    async initFromRoute() {
      const idPersonal = this.$route.query.idPersonal

      if (idPersonal) {
        this.loading = true
        await this.loadPersonalForRollCall(idPersonal)
        this.activeStep = 2
        this.loading = false
      }
    },

    async loadPersonalForRollCall(idPersonal) {
      const parsedId = isNaN(Number(idPersonal)) ? idPersonal : Number(idPersonal)

      await this.fetchPersonalById(parsedId)
      this.selectedPersonal = this.personalSingle

      if (this.selectedPersonal) {
        await Promise.all([
          this.fetchArmasPersonal(this.selectedPersonal.idPersonal),
          this.fetchBitacoraEntregaRecepcion(),
        ])

        if (this.armasPersonal.length === 0) {
          this.SET_SNACKBAR_MESSAGE('El personal seleccionado no tiene armas asignadas.')
        }
      } else {
        this.SET_SNACKBAR_MESSAGE('No se encontró información del personal.')
      }
    },

    searchCuip: function () {
      this.loading = true
      this.selectedPersonal = this.personal.find((element) => element.CUIP == 'GAAJ751110H29199421')
      if (this.selectedPersonal || !this.selectedPersonal === undefined) {
        this.successfulCuipSearch = true
      } else {
        this.successfulCuipSearch = false
      }
      console.log(this.selectedPersonal)

      this.loading = false
    },

    triggerFetchPersonalWeapons: async function (personal) {
      this.selectedPersonal = personal
      this.fetchingPersonalWeapons = true
      await Promise.all([
        this.fetchArmasPersonal(this.selectedPersonal.idPersonal),
        this.fetchBitacoraEntregaRecepcion(),
      ])
      this.fetchingPersonalWeapons = false
      if (this.armasPersonal.length > 0) {
        this.activeStep = 2
      } else {
        this.SET_SNACKBAR_MESSAGE('El personal seleccionado no tiene armas asignadas.')
      }
    },

    getWeaponStatusLabel: function (armaPersonal) {
      var bitacora = []

      bitacora = this.bitacora.filter((entregaRecepcion) => {
        return entregaRecepcion.fk_idArmaPersonal == armaPersonal.idArmaPersonal
      })

      if (bitacora.length > 0) {
        this.x = bitacora[bitacora.length - 1].fk_idTipoEntrega

        if (bitacora[bitacora.length - 1].fk_idTipoEntrega == 2) {
          return 'En campo'
        } else return 'En armería'
      } else return 'En armería'
    },

    weaponStatusToggleHandler: function (weapon) {
      this.weaponToUpdate = weapon
      if (this.weaponToUpdate.Arma.fk_idEstatus == 1) {
        this.downloadWeaponDialog = true
      } else {
        this.triggerUpdateWeaponStatus()
      }
    },

    triggerUpdateWeaponStatus: async function () {
      if (this.weaponToUpdate.Arma.fk_idEstatus == 1) {
        var receiptType = 2
      } else {
        var receiptType = 1
      }

      await this.saveEntregaRecepcionArma({
        idPersonal: this.weaponToUpdate.fk_idPersonal,
        fk_idTipoEntrega: receiptType,
        fk_idArmaPersonal: this.weaponToUpdate.idArmaPersonal,
        fecha: moment().format(this.API_DATE_FORMAT),
        armaDescargada: 1,
      })
      this.closeDownloadWeaponDialog()
    },

    closeDownloadWeaponDialog: function () {
      this.downloadWeaponDialog = false
      this.downloadWeaponStatus = false
      this.weaponToUpdate = null
    },

    getWeaponStatusToggleValue: function (status_id) {
      if (status_id == 1) {
        return 1
      } else {
        return 0
      }
    },

    goBack: function () {
      if (this.$route.query.idPersonal) {
        this.$router.back()
        return
      }

      this.selectedPersonal = null
      this.activeStep = 1
    },

    async triggerSaveEntregaRecepcion(armaPersonal, event) {
      if (event) {
        await this.saveEntregaRecepcionArma({
          idPersonal: armaPersonal.fk_idPersonal,
          fk_idTipoEntrega: 2,
          fk_idArmaPersonal: armaPersonal.idArmaPersonal,
          armaDescargada: false,
        })
      } else {
        await this.saveEntregaRecepcionArma({
          idPersonal: armaPersonal.fk_idPersonal,
          fk_idTipoEntrega: 1,
          fk_idArmaPersonal: armaPersonal.idArmaPersonal,
          armaDescargada: true,
        })
      }
      await this.fetchBitacoraEntregaRecepcion()
    },

    getArmaPersonalEstatus: function (armaPersonal) {
      var bitacora = []

      bitacora = this.bitacora.filter((entregaRecepcion) => {
        return entregaRecepcion.fk_idArmaPersonal == armaPersonal.idArmaPersonal
      })

      if (bitacora.length > 0) {
        this.x = bitacora[bitacora.length - 1].fk_idTipoEntrega

        if (bitacora[bitacora.length - 1].fk_idTipoEntrega == 2) {
          return true
        } else return false
      } else return false
    },

    async triggerCancelaArmaPersonal(armaPersonal) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_CANCELAR_ARMA,
        props: {
          armaPersonal,
          onConfirmCancel: async () => {
            await this.cancelaArmaPersonal(armaPersonal)
            await this.fetchArmasPersonal(this.selectedPersonal.idPersonal)
            this.$store.commit('dialog/CLOSE_DIALOG')
          },
        },
      })
    },

    openEditArmaDialog(armaPersonal) {
      this.armaPersonalAEditar = armaPersonal
      this.editArmaSeleccionada = null
      this.editArmaDialog = true
    },

    closeEditArmaDialog() {
      this.editArmaDialog = false
      this.editArmaSeleccionada = null
      this.armaPersonalAEditar = null
    },

    async confirmEditArmaPersonal() {
      this.loadingEditArma = true
      try {
        await this.editArmaPersonal({
          fk_idPersonal: this.armaPersonalAEditar.fk_idPersonal,
          idArmaPersonal: this.armaPersonalAEditar.idArmaPersonal,
          fk_idArma: this.editArmaSeleccionada,
          fk_idTipoAsignacion: this.armaPersonalAEditar.fk_idTipoAsignacion,
          fechaAsignado: this.armaPersonalAEditar.fechaAsignado,
          comentario: this.armaPersonalAEditar.comentario,
        })
        await this.fetchArmasPersonal(this.selectedPersonal.idPersonal)
        this.closeEditArmaDialog()
      } finally {
        this.loadingEditArma = false
      }
    },

    async openMunicionesArmaDialog(armaPersonal) {
      await this.fetchMunicionArma(armaPersonal.idArmaPersonal)
      this.municionesArmaDialog = true
    },

    buscaPersonal() {
      return new Promise(async () => {
        setTimeout(await this.searchPersonal(this.busquedaPersonal), 200)
        this.loadingBusqueda = false
      })
    },

    triggerSearchPersonal() {
      this.loadingBusqueda = true
      if (this.busquedaPersonal.CUIP !== '') {
        this.buscaPersonal()
      } else {
        this.loadingBusqueda = false
        this.RESET_BUSQUEDA_PERSONAL()
      }
    },

    setPersonalArma(id_personal) {
      this.armaPersonal.fk_idPersonal = id_personal
      this.activeStepButtonHandler()
    },
  },
}
</script>
